// Circular GodTended emblem, pre-cropped with the white background removed.
const LOGO = "/godtended-logo.png";

export const LogoMark = ({ className = "", ring = false }) => (
  <div
    className={`relative overflow-hidden rounded-full ${
      ring ? "ring-1 ring-gold/40" : ""
    } ${className}`}
  >
    <img src={LOGO} alt="GodTended" className="h-full w-full object-cover" />
  </div>
);
